import api from './api';

export const getDocumentByUuid = (uuid) => api.post(`/v1/document/${uuid}`);

export const getTenantDocumentByUuid = (documentUuid) =>
  api.get(`/v1/tenant/document/${encodeURIComponent(documentUuid)}`);

export const listDocuments = (body) => api.post(`/v1/tenant/document/list`, body);

export const listDocumentsByTenant = (body) => api.post(`/v1/tenant/document/list`, body);

export const createDocument = (body) => api.post(`/v1/tenant/document/create`, body);

export const createDocumentByTenant = (body) => api.post(`/v1/tenant/document/create`, body);

export const attachDocument = (body) => api.post(`/v1/tenant/document/attach`, body);

export const attachDocumentbyTenant = (body) => api.post(`/v1/tenant/document/attach`, body);

export const getDocumentAgents = (uuid, tenant_id) => api.get(`/v1/document/${uuid}/agents`, { params: { tenant_id } });

export const unassignAgentFromDocument = (uuid, agent_id, tenant_id) => 
  api.post(`/v1/workspace/document/${uuid}/agents/${agent_id}/unassign`);


export const assignAgentToDocument = (body) => api.post(`/v1/tenant/document/assign-agent`, body);

export const duplicateDocument = (documentUuid) => api.post(`/v1/document/${documentUuid}/duplicate`);

export const renameDocument = (body) => api.post(`/v1/tenant/document/rename`, body);

export const deleteDocument = (body) => api.post(`/v1/workspace/document/delete`, body);

// ⚠️ TODO: Cambiar endpoint cuando esté disponible
// Actualmente apunta temporalmente a /v1/document/delete (scope global)
// Debe cambiarse a: /v1/tenant/document/delete (scope local) cuando el endpoint esté listo
// NOTA: Este endpoint dará error (DOC_NOT_FOUND) para documentos que no estén en scope global
// hasta que se implemente el endpoint de scope local
export const deleteDocumentByTenant = (body) => api.post(`/v1/document/delete`, body);
